import React__default, { createContext } from 'react';

const CheckoutCartContext = createContext({});
const CheckoutCartProvider = ({ children, ...props }) => {
    return (React__default.createElement(React__default.StrictMode, null,
        React__default.createElement(CheckoutCartContext.Provider, { value: {} }, children)));
};

export { CheckoutCartContext, CheckoutCartProvider };
//# sourceMappingURL=CheckoutCartContext.js.map
